import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {HmHeaderComponent} from './hm-header.component';
import {SharedModule} from '../../../shared/shared.module';

@NgModule({
    declarations: [HmHeaderComponent],
    imports: [CommonModule, RouterModule, SharedModule],
    exports: [HmHeaderComponent],
})
export class HmHeaderModule {}
